<script>
  import Link from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';

  export let leader;

  function getLeaderLink() {
    return `/leaders/view/${leader.id}`;
  }
</script>

<Card hover>
  <Link href={getLeaderLink()}>
    <div class="u--padall">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-12 text-center">
        <Avatar larger avatar={leader.avatar} />
      </div>
      <div class="cell small-12 medium-12 text-center">
        <div class="u--padall">
          <h3>
            {leader.firstName} {leader.lastName}
          </h3>
        </div>
      </div>
    </div>
  </div>
  </Link>
</Card>


